import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { BaseService } from '../../http/base.service';
import { UserService } from '../../user/user.service';

export const YaKeyGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const service = inject(BaseService);
    const userService = inject(UserService);

    // Check if there is at least one Yandex API key
    // If not, redirect to the API key creation page

    return  service.list('api/ya/api-keys')
        .pipe(
            switchMap((keys: any[]) => {
                if (keys.length === 0 || (!userService.isPremium && !userService.isTrial)) {
                    const urlTree = router.parseUrl(`/ya/settings/api-keys?redirectURL=${state.url}`);
                    return of(urlTree);
                }
                return of(true);
            }
        ));
}
